import React, { useState } from "react"
import { Button } from "@prosolve/common-components-ui"
import PasswordModal from "./PasswordModal"

export default ({
  userAccount
}) => {
  const [isOpen, setIsOpen] = useState()

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        Change
      </Button>
      {isOpen &&
        <PasswordModal userAccount={userAccount} onClose={() => setIsOpen(false)} />
      }
    </>
  )
}
